import { styled, css } from "styled-components";

const baseFooter = css`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  min-height: 64px;
  padding: 2rem 2rem calc(2rem + env(safe-area-inset-bottom));
  /* Transparent so the fixed blue gradient on body::before shows through. */
  background-color: transparent;
  position: relative;
`;

export const FooterContainer = styled.footer`
  ${baseFooter}
  flex-direction: column;
  gap: 2rem;
  margin-top: auto;

  @media (max-width: 768px) {
    gap: 16px;
  }
  @media (max-width: 400px) {
    gap: 8px;
  }
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;

  @media (max-width: 400px) {
    gap: 8px;
  }
`;

export const Link = styled.a`
  color: #a1a1aa;
  font-family: Figtree;
  text-align: center;
  white-space: nowrap;
  font-size: 12px;
  cursor: pointer;
  font-weight: 400;
  letter-spacing: -0.06px;

  &:hover {
    opacity: 0.65;
  }
`;

export const DesktopRow = styled(FooterRow)`
  display: flex;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileRow = styled(FooterRow)`
  display: none;

  @media (max-width: 768px) {
    display: flex;
  }
`;
